export default __webpack_public_path__ + "static/media/hessahStore10.8bf9fc58.jpg";